import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../../services/api';
import './Auth.css';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('E-posta adresiniz doğrulanıyor, lütfen bekleyiniz...');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Doğrulama belirteci bulunamadı.');
      return;
    }

    const verify = async () => {
      try {
        const res = await authApi.verifyEmail(token);
        if (res.success) {
          setStatus('success');
          setMessage(res.message || 'E-posta adresiniz başarıyla doğrulandı!');
          setTimeout(() => {
            navigate('/login?verified=true', { state: { registeredEmail: (res as any).email || '' } });
          }, 2500);
        }
      } catch (err: any) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Doğrulama bağlantısı geçersiz veya süresi dolmuş.');
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="verification-status-box">
          {status === 'loading' && (
            <>
              <div className="status-spinner"></div>
              <h2>Doğrulanıyor...</h2>
              <p>{message}</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="status-icon success">✅</div>
              <h2>Tebrikler!</h2>
              <p>{message}</p>
              <span className="redirect-hint">Giriş sayfasına yönlendiriliyorsunuz...</span>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="status-icon error">❌</div>
              <h2>Doğrulama Başarısız</h2>
              <p>{message}</p>
              <button className="auth-btn-primary" onClick={() => navigate('/login')}>
                Giriş Sayfasına Dön
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
